import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { lazy, Suspense, useEffect } from "react";
import FOF from "./Pages/FOF";
import MainLayout from "./Pages/MainLayout";
import Loading from "./Components/Loading/Loading";
import ReactGA from "react-ga";
const AddProduct = lazy(() => import("./Components/AddProduct/AddProduct"));

const ProductDetail = lazy(() =>
  import("./Components/ProductDetail/ProductDetail")
);

const Login = lazy(() => import("./Pages/AuthPages/Login/Login"));
const Signup = lazy(() => import("./Pages/AuthPages/Signup/Signup"));
const Verify = lazy(() => import("./Pages/AuthPages/Verify/verify"));
const Landing = lazy(() => import("./Pages/Landing"));
const User = lazy(() => import("./Pages/User"));
const Favorites = lazy(() => import("./Pages/Favorites"));
const Locations = lazy(() => import("./Pages/Locations/Locations"));
const ForgotPassword = lazy(() =>
  import("./Pages/AuthPages/ForgotPassword/ForgotPassword")
);

const ChangePassword = lazy(() =>
  import("./Pages/AuthPages/ChangePassword/ChangePassword")
);
const Myads = lazy(() => import("./Pages/Myads"));
const PrivacyPolicy = lazy(() => import("./Pages/Privacy"));
const TRACKING_ID = "G-28L4SYCWPR"; // OUR_TRACKING_ID

function App() {
  ReactGA.initialize(TRACKING_ID);
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <div className=" min-h-screen bg-white w-scneen flex flex-col items-center text-gray-900 dark:text-gray-200  dark:bg-gray-900">
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<MainLayout />}>
            <Route
              index
              element={
                <Suspense fallback={<Loading />}>
                  <Landing />
                </Suspense>
              }
            />
            <Route
              path="estate/:id"
              element={
                <Suspense fallback={<Loading />}>
                  <ProductDetail />
                </Suspense>
              }
            />

            <Route
              path="favorite"
              element={
                <Suspense fallback={<Loading />}>
                  <Favorites />
                </Suspense>
              }
            />
            <Route
              path="user/my-ads"
              element={
                <Suspense fallback={<Loading />}>
                  <Myads />
                </Suspense>
              }
            />
            <Route
              path="location"
              element={
                <Suspense fallback={<Loading />}>
                  <Locations />
                </Suspense>
              }
            />

            <Route
              path="user"
              element={
                <Suspense fallback={<Loading />}>
                  <User />
                </Suspense>
              }
            />
            <Route
              path="privacy-policy"
              element={
                <Suspense fallback={<Loading />}>
                  <PrivacyPolicy />
                </Suspense>
              }
            />

            <Route
              path="add-product"
              element={
                <Suspense fallback={<Loading />}>
                  <AddProduct />
                </Suspense>
              }
            ></Route>
            <Route path="*" element={<FOF />} />
          </Route>

          <Route>
            <Route
              path="/login"
              element={
                <Suspense fallback={<Loading />}>
                  <Login />
                </Suspense>
              }
            />
            <Route
              path="/signup"
              element={
                <Suspense fallback={<Loading />}>
                  <Signup />
                </Suspense>
              }
            />
            <Route
              path="/verify"
              element={
                <Suspense fallback={<Loading />}>
                  <Verify />
                </Suspense>
              }
            />
            <Route
              path="/forgot-password"
              element={
                <Suspense fallback={<Loading />}>
                  <ForgotPassword />
                </Suspense>
              }
            />
            <Route
              path="/change-password"
              element={
                <Suspense fallback={<Loading />}>
                  <ChangePassword />
                </Suspense>
              }
            />
            <Route path="*" element={<FOF />} />
          </Route>
        </Routes>
        {/* <Navbar />
        <Routes>
          <Route path="user" element={<AuthLayout />} />
        </Routes> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
